import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {
  isVideoPlaying = false;

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router, private titleService: Title, private meta: Meta) {
    this.titleService.setTitle("RankAhead: Faster and Auto Page Indexing on Google");
    this.meta.addTag({
      name: 'description',
      content: 'Seeking faster website indexing on Google? Rank Ahead can expedite the process, ensuring your web pages are automatically indexed faster on Google.'
    });

   
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    let video = document.getElementById("guide-video");
    (<any>video).addEventListener("pause", (event: any) => {
      this.isVideoPlaying = false;
    });

    (<any>video).addEventListener("play", (event: any) => {
      this.isVideoPlaying = true;
    });
  }

  routeToSignin() {
    this.router.navigateByUrl("/signin");
  }

  playVideo() {
    let video = document.getElementById("guide-video");

    (<any>video).play();

    this.isVideoPlaying = true;
  }


}
